import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Tooltip } from '@ets/design-system';

import DOMElementFactory from 'Editor/services/DOMUtilities/DOMElementFactory/DOMElementFactory';
import { DISPLAY_TYPES, ELEMENTS } from 'Editor/services/consts';
import styles from './ListOfTablesElement.module.scss';
import { BaseBlockElement } from '../../BaseViewBuilder';
import { StylesUtils } from 'Editor/services/Edition_v2/Managers/Styles/StylesUtils';
import { Root } from 'react-dom/client';
import ReactUtils from '_common/utils/ReactUtils';

const ListOfTablesElementContent = () => {
  const intl = useIntl();

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'CONTENT_CANNOT_BE_EDITED' })}
      testId="list-of-tables-cannot-be-edited"
    >
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <Icon icon="list" size="4" testId="list-of-tables" />
        </div>
        <div className={styles.info}>
          <FormattedMessage id={'EDITOR_DOCUMENT_LIST_OF_TABLES'} />
        </div>
      </div>
    </Tooltip>
  );
};

export class ListOfTablesElement extends BaseBlockElement {
  private container?: HTMLElement;
  private rootReactContainer?: Root;

  get selectableContent() {
    return this.container?.childNodes[0]?.childNodes[1] || null;
  }

  connectedCallback() {
    super.connectedCallback();
    this.buildElement();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    ReactUtils.unmountReactComponent(this.rootReactContainer);
  }

  get ALLOWED_STYLE_ATTRIBUTES() {
    return StylesUtils.getAllowedBlockStyles('tot');
  }

  get displayType() {
    return DISPLAY_TYPES.BLOCK;
  }

  get isEditable() {
    return false;
  }

  get isDeletable() {
    return !this.isLocked;
  }

  get isSplitable() {
    return false;
  }

  get isSelectable() {
    return true;
  }

  buildElement() {
    this.innerHTML = '';

    // this.setAttribute('contentEditable', false);
    this.setAttribute('spellcheck', 'false');

    this.container = DOMElementFactory.buildElement('div');
    this.container.setAttribute('class', styles.container);

    this.appendChild(this.container);
    this.rootReactContainer = ReactUtils.createReactRoot(this.container);
    ReactUtils.renderReactComponent(<ListOfTablesElementContent />, this.rootReactContainer);
  }
}

if (!window.customElements.get(ELEMENTS.ListOfTablesElement.IDENTIFIER)) {
  window.customElements.define(ELEMENTS.ListOfTablesElement.IDENTIFIER, ListOfTablesElement);
}
